// config.js
const apiUrl = 'https://kitchenm.onrender.com'; // Replace with your actual API base URL
export default apiUrl;
   
